export const removeAlreadySelectedSocialFromSelect = (total_list, selected) => {
  const tl = total_list?.filter(
    tlname => selected?.[tlname?.name] === undefined
  )

  return tl
}
